import React from 'react';
import IntroSection from '../../component/introSection';
import ResponsivePaddingWrapper from '../../component/responsive/responsivePaddingWrapper';
import { FontWeightType, LabelMedium, TitleMedium } from '../../component/Text';
import { useMobile } from '../../hook/usePlatform';

const EventPage : React.FC = () => {
  const isMobile = useMobile();
  return (
    <div>
      <IntroSection
        title="[이벤트]"
        content="공감과 이해가 함께하는 시럽 인연"
      />
      <ResponsivePaddingWrapper style={{ display: 'flex', borderTop: '1px solid #979593' }}>
        <div
          style={{ marginTop: 16, padding: 16, cursor: 'pointer' }}
          onClick={() => {
            window.location.href = '/events/1';
          }}
        >
          <img src="/image/sirup_premium_event.png" width={isMobile ? 300 : 500} style={{ objectFit: 'cover' }} alt="시럽 인연 첫 번째 테스터 모집" />
          <div style={{ paddingInline: 0, marginBottom: 32 }}>
            <TitleMedium style={{ fontFamily: 'inter', marginTop: 32 }} fontWeight={FontWeightType.w900}>[EVENT] 시럽 인연 오픈 기념 프로모션!</TitleMedium>
            <LabelMedium style={{ fontFamily: 'inter', color: '#707070' }}>2025-03-12 ~ 선착순 모집 시 종료</LabelMedium>
          </div>
        </div>
      </ResponsivePaddingWrapper>
    </div>
  );
};

export default EventPage;
